import { render, staticRenderFns } from "./loadmore.vue?vue&type=template&id=0e2c1d64&"
import script from "./loadmore.vue?vue&type=script&lang=ts&"
export * from "./loadmore.vue?vue&type=script&lang=ts&"
import style0 from "./loadmore.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports